var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833496,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#26C3C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0208 17.8376L28.8458 17.0126C29.5293 16.3291 30.6373 16.3291 31.3208 17.0126C32.0042 17.696 32.0042 18.8041 31.3208 19.4876L30.4958 20.3125M28.0208 17.8376L22.4713 23.387C22.0484 23.81 21.7484 24.3398 21.6033 24.9201L21 27.3333L23.4133 26.73C23.9935 26.585 24.5233 26.2849 24.9463 25.862L30.4958 20.3125M28.0208 17.8376L30.4958 20.3125",
    stroke: "#26C3C0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1667 25.2513C30.1667 27.9909 30.1667 29.3606 29.4102 30.2826C29.2717 30.4514 29.1169 30.6061 28.9481 30.7446C28.0262 31.5013 26.6563 31.5013 23.9167 31.5013H23.5002C20.3575 31.5013 18.7861 31.5013 17.8098 30.525C16.8335 29.5487 16.8335 27.9773 16.8335 24.8346V24.418C16.8335 21.6784 16.8335 20.3086 17.5901 19.3867C17.7286 19.2179 17.8834 19.0631 18.0522 18.9246C18.9742 18.168 20.3439 18.168 23.0835 18.168",
    stroke: "#26C3C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/Edit_Button.26b6a9eb83ea455e893f572fbc42b453.svg";
export { ForwardRef as ReactComponent };